import React from "react";
import Form from "./Components/Form";
import Header from "./Components/Header";

function App() {
  
  return (
    <div className="container">
      <Header/>
      <Form/>
    </div>
  );
}

export default App;
